export const PRICE_ID_BASIC_PLAN = 1;
